import { render } from "./JoinFailPopup.vue?vue&type=template&id=1476cc02&scoped=true&ts=true"
import script from "./JoinFailPopup.vue?vue&type=script&lang=ts"
export * from "./JoinFailPopup.vue?vue&type=script&lang=ts"

import "./JoinFailPopup.vue?vue&type=style&index=0&id=1476cc02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1476cc02"]])

export default __exports__